import React, { Component } from 'react';

export default class Company extends Component {
  constructor(props){
    super(props)
		this.state = {
			value: '',
			errorMsg: ''
		}
  }
  handleChange(e){
		let value = e.target.value
		window.company = value
		window.myForm.addHiddenFields({
			'Company': value
		});
		this.setState({value})
		this.refreshCompanyField()
	}
	refreshCompanyField(){
		document.getElementById("Company").dispatchEvent(window.companyUpdate);
	}
	validate(){
		let currentVal = this.state.value
		if (!currentVal || currentVal.length < 2 ){
			this.setState({
				errorMsg: 'Please enter your company.'
			})
			return false;
		}else{
			this.setState({
				errorMsg: null
			}, function(){
				this.props.setValue(this.state.value, false)
			})
			return true;
		}
	}
	setDefaultValue(value){
    this.setState({value},function(){
    	this.props.setValue(value)
    })
  }
	render(){
		return (
			<div className={"field-wrapper " + (this.state.errorMsg ? ' invalid' : '')}>
				<label>Company name</label>
				<input type="text" onChange={ e => this.handleChange(e)} onBlur={this.validate.bind(this)} />
				<span className="error-msg">{this.state.errorMsg}</span>
			</div>
		)
	}
}	
